import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Chip,
} from '@mui/material';
import { FaTrash } from 'react-icons/fa';
import { EmployeeAvatar } from '../../../common/EmployeeAvatar';

const ConfigureTalkingPointCard = ({
  point,
  onRemove,
  permissions,
}) => {
  const question = point.talkingPoint?.question || point.question || point.systemTalkingPoint?.question;
  const instructions = point.talkingPoint?.instructions || point.instructions || point.systemTalkingPoint?.instructions;
  const isSystem = point.talkingPoint?.isSystemTalkingPoint;

  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: point.isDiscussed ? '#F0FDF4' : '#fff',
        border: '1px solid',
        borderColor: point.isDiscussed ? '#86EFAC' : '#E2E8F0',
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 200,
        transition: 'all 0.2s ease',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
          borderColor: point.isDiscussed ? '#86EFAC' : '#CBD5E1',
        },
      }}
    >
      {/* Header with type badge and added by */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {isSystem ? (
            <Chip label="System" size="small" color="primary" sx={{ fontSize: '10px', height: 20 }} />
          ) : (
            <Chip label="Custom" size="small" sx={{ fontSize: '10px', height: 20, backgroundColor: '#F59E0B', color: '#fff' }} />
          )}
          {point.addedByEmployee && (
            <>
              <Typography variant="caption" color="text.secondary">•</Typography>
              <EmployeeAvatar employee={point.addedByEmployee} size={20} />
              <Typography variant="caption" color="text.secondary">
                {point.addedByEmployee.fullName}
              </Typography>
            </>
          )}
        </Box>
        {permissions.canAddTalkingPoints && (
          <IconButton
            size="small"
            onClick={() => onRemove(point)}
            sx={{ color: 'error.main', p: 0.5 }}
          >
            <FaTrash size={14} />
          </IconButton>
        )}
      </Box>

      {/* Question */}
      <Typography
        variant="body1"
        fontWeight={500}
        sx={{
          textDecoration: point.isDiscussed ? 'line-through' : 'none',
          color: point.isDiscussed ? '#6B7280' : '#1F2937',
          mb: 1,
          flex: 1,
          lineHeight: 1.4,
        }}
      >
        {question}
      </Typography>

      {/* Instructions */}
      {instructions && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mb: 1.5,
            fontSize: '0.8125rem',
            lineHeight: 1.5,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {instructions}
        </Typography>
      )}

    </Box>
  );
};

export default ConfigureTalkingPointCard;
